/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/users" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdChartsUsers } from "./constants";
import type { AppsAppGroupIdChartsUsersResult } from "./types";

export const getAppsAppGroupIdChartsUsers = reactQueryFetcherAdapter(
  appsAppGroupIdChartsUsers,
  (
    signal: AbortSignal,
    appGroupId: string,
    startDate: number,
    endDate: number
  ): Promise<AppsAppGroupIdChartsUsersResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/users`,
      "GET",
      { start_date: startDate, end_date: endDate },
      { signal }
    );
  }
);
